/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const instagram_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#instagram_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M18.595 5.235h.346M6.74.75h10.5a6 6 0 0 1 6 6v10.5a6 6 0 0 1-6 6H6.74a6 6 0 0 1-6-6V6.75a6 6 0 0 1 6-6ZM16.99 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm2.03-6.765c0 .183-.16.243-.248.243-.091 0-.251-.06-.251-.243 0-.197.16-.257.251-.257.089 0 .249.06.249.257Z"
      />
    </g>
    <defs>
      <clipPath id="instagram_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default instagram_medium
